"use client";
import type { ICommonAppData } from "@/lib/types/sanity";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import styles from "./LayoutDynamicAdnuntiusAd.module.css";
import classNames from "classnames";

const DAdnuntiusAd = dynamic(() =>
    import('@/components/framework/AdnuntiusAd').then((mod) => mod.default),
    { ssr: false }
);

type DynamicTopAdnuntiusAdProps = {
    appData: ICommonAppData;
}

export default function LayoutDynamicTopAdnuntiusAd({ appData }: DynamicTopAdnuntiusAdProps) {
    const pathname = usePathname();
    const _hideTopAdOnMobile = hideTopAdOnMobile(pathname);

    return <div className={classNames(styles.TopAd, _hideTopAdOnMobile && styles.hide)}>
        <DAdnuntiusAd appData={appData} index={0} debugLabel="webLayout" showAdAfterFirstScroll={pathname === "/"} hideOnMobile={_hideTopAdOnMobile} />
    </div>

}

function hideTopAdOnMobile(pathname: string) {
    if (pathname.startsWith("/film/") && pathname.length > 6) {
        return true;
    }
    return pathname === "/program" || pathname === "/velgfilm" || pathname === "/kommer";
}